var _ = require("lodash");

var { FunctionId } = require("../typing/typing");

var config = {};
config.Game={
  instantlyBotLog: false,
  reactionStateLog: false,
};

var Forms = require("./Forms");
var { EmptyForm } = Forms;
var Messages = require("./Messages");
var { logState } = require("./Processes");

/**
 * @constructor
 * @param getFormReaction - a function of state that returns undefined
 *   or an object with `form` and `reaction`.
 * @alias module:Game
 * @alias Game
 * @memberof module:Game
 */
function Game(getFormReaction) {
  if(_.keys(this).length > 0) return new Game(getFormReaction);
  this.getFormReaction = getFormReaction;
  this.journaling();
}

Game.prototype = {

  /**
   * Game transformation: enable message journaling.
   * By default a message is stored in `state.msg`,
   * after each move it might be replaced with another object.
   * Journaling collects a message to an array so that
   * `state.msg` is an array of transforming game's `state.msg`.
   * @return Game
   */
  journaling: function() {
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      return {
        form: fr.form,
        reaction: function(v) {
          var r = fr.reaction(v);
          r.msg = Messages.concatMsg(state.msg,
                    Messages.getMsgObject(r.msg, state.curTime));
          return r;
        }
      };
    };
    return this;
  },
  
  /**
   * Game transformation:
   * wraping each form with MessageForm,
   * supplying a message stored in `state.msg`.
   * @return Game
  */
  supplyMessage: function() {
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      return {
        form: Forms.MessageForm(fr.form, state.msg[state.subj]),
        reaction: fr.reaction
      };
    };
    return this;
  },

  /**
   * Game transformation:
   * fold `subjects` to a single subject `newSubj`.
   * @param subjects - an array of strings or a string predicate
   * @param newSubj - a string
   * @return Game
   */
  foldSubjects: function(subjects, newSubj) {
    function subjArray(predicate, state) {
      var s = _.clone(state);
      var arr = [];
      s.subj = function(sj) {
        if(predicate(sj)) {
          arr.push(String(sj));
          return true;
        }
        return false;
      };
      getFormReaction1(s);
      return _.uniq(arr);
    }
    function frArray(subjects, state) {
      var frs = subjects.map(function(sj) {
        var s = _.clone(state);
        s.subj = sj;
        return getFormReaction1(s);
      });
      return frs;
    }
    // replace getFormReaction
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      if(state.subj != newSubj) return getFormReaction1(state);
      // subjects array
      var sbjs = _.isFunction(subjects) ? subjArray(subjects, state) : subjects;
      // form-reaction corresponding to subjects
      var frs = frArray(sbjs, state);
      if(_.every(frs, _.isUndefined)) return undefined;
      return {
        form: Forms.SumSubj(sbjs,
                frs.map(function(fr) { return fr ? fr.form : EmptyForm; })),
        reaction: function(v) {
          if(config.Game.reactionStateLog)
            console.log("foldSubjects reaction started");
          // chosen move option corresponds to subjects[v.mark]
          var r = frs[v.mark].reaction(v.value);
          if(_.includes(subjects, r.subj)) r.subj = newSubj;
          // r.msg = replaceSubjInMessage(r.msg);
          if(config.Game.reactionStateLog) {
            console.log("foldSubjects reaction finished with…");
            // logState(r);
          }
          return r;
        }
      };
    };
    return this;
  },


  /* alternative version, no testing */
  _implementBot: function(subj, bot) {
    this.subjects = _.pull(this.subjects, subj);
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      while(state.subj == subj) {
        var fr = getFormReaction1(state);
        if(!fr) return fr;
        var v = bot(fr.form);
        state = fr.reaction(v);
      }
      // assert (subj != state.subj)
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      return {
        form: fr.form,
        reaction: function(v) {
          if(config.Game.reactionStateLog)
            console.log("implementBot reaction started");
          var r = fr.reaction(v);
          while (subj == r.subj) {
            console.log(subj + " bot is activated");
            // FormReaction for the bot
            var fr$ = getFormReaction1(r);
            //check whether fr$ undefined
            if(!fr$) return r;
            // bot's move
            var v$ = bot(fr$.form);
            // reaction result
            var r$ = fr$.reaction(v$);
            // rewriting state
            r = r$;
          }
          if(config.Game.reactionStateLog) {
            console.log("implementBot reaction finished with…");
            logState(r);
          }
          return r;
        }
      }
    };
  },
  
  /**
   * Game transformation: 
   * exclude subject's explicit moves by playing them automatically by a bot.
   * @param {String} subj
   * @param {Function} bot - a function `form -> r`
   *   (a reaction's result depending on a form)
   * @return Game
  */  
  implementBot: function(subj, bot) {
    FunctionId(bot);
    // rewrite getFormReaction
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      // assert(subj != sbj)
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      return {
        form: fr.form,
        reaction: function(v) {
          if(config.Game.reactionStateLog)
            console.log("implementBot reaction started");
          var r = fr.reaction(v);
          if (subj != r.subj) {
            if(config.Game.reactionStateLog) {
              console.log("The next playing subject " + r.subj +
                " is not implemented by the bot [" + subj + "]");
            }
            if(config.Game.reactionStateLog) logState(r);
          }
          // if next subject is attached to the bot,
          // its move must be simulated
          while (subj == r.subj) {
            console.log(subj + " bot is activated");
            // FormReaction for the bot
            var fr$ = getFormReaction1(r);
            //check whether fr$ undefined
            if(!fr$) return r;
            // bot's move
            var v$ = bot(fr$.form);
            if(config.Game.reactionStateLog) {
              console.log("Bot's choice:");
              console.log(fr$.form);
              console.log(v$);
            }
            // reaction result
            var r$ = fr$.reaction(v$);
            if(config.Game.reactionStateLog) {
              console.log(_.cloneDeep(r$));
            }
            // rewriting state
            r = r$;
          }
          
          if(config.Game.reactionStateLog) {
            console.log("implementBot reaction finished with…");
            logState(r);
          }
          return r;
        }
      };
    };
    return this;
  },
  
  /**
   * Turning function specifies a turn, i.e. which subject must make his move.
   * `this` refers to the host Game object.
   * @callback Game~Turning
   * @param {Object} state - a previous state
   * @param {Object} v - an option the last player chose
       (i.e. a move he made)
   * @param {Object} r - a next state
   * @this Game
   * @return {String}
   */
  
  /**
   * Game transformation:
   * substitute undefined `subj` in `r` (move result)
   *   with `turning(state, v, r)`.
   * @param {Turning} turning - turn function
   * @return Game
   */
  setTurning: function(turning) {
    turning = turning.bind(this);
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      return {
        form: fr.form,
        reaction: function(v) {
          if(config.Game.reactionStateLog) {
            console.log("setTurning reaction started");
          }
          var r = fr.reaction(v);
          if(r.subj) return r;
          r.subj = turning(state, v, r);
          if(config.Game.reactionStateLog) {
            console.log("r.subj set to " + r.subj);
            console.log("setTurning reaction finished with…");
            logState(r);
          }
          return r;
        }
      };
    };
    return this;
  },
  
  /*
    changes format of istate field
    inject translates the current istate format to new one
    project translates backward
  */
  extendIState: function(inject, project) {
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      state.istate = project(state.istate);
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      return {
        form: fr.form,
        reaction: function(v) {
          var r = fr.reaction(v);
          r.istate = inject(r.istate);
          return r;
        }
      };
    };
    return this;
  },
  
  extendState: function(inject, project) {
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      state = project(state);
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      return {
        form: fr.form,
        reaction: function(v) {
          return inject(fr.reaction(v));
        }
      };
    };
    return this;
  },
  /**
   * Game transformation:
   * set a semantic of time-based operations.
   * A few fields of `state` introduces, including a timestamp of current time
   * and a set of timestamps subjects will be able to make there next move at.
   * It also set a turning according to these timestamps.
   * @return Game
   */
  introduceTime: function() {
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      if(config.Game.reactionStateLog) {
        console.log("state.curTime=" + state.curTime);
      }
      fr.form.istate = state.istate; // FIX: это дикий костыль, который должен быть исключен
      return {
        form: Forms.TimeForm(fr.form, state.curTime),
        reaction: function(v) {
          /* suplimentary function 
             returns an array of subjects whose timestamp is in the present
             and whose form is non-empty
          */
          function getActiveSubjects(st) {
            return _(st.timestamps)
              .pickBy(function(ts) { return ts == st.curTime; })
              .keys()
              .filter(function(sj) {
                  var st1 = _.clone(st);
                  st1.subj = sj;
                  var fr1 = getFormReaction1(st1);
                  return !fr1 || fr1.form.isEffectivelyEmpty();
                })
              .value();
          }
          
          // assert (state.timestamps[state.subj] == state.curTime)
          
          // an array of subjects acting in time
          var subjects = _.keys(state.timestamps);
          
          if(config.Game.reactionStateLog) {
            console.log("introduceTime reaction started");
          }
          
          if(v == "WAIT") {
            state = _.cloneDeep(state);
            /* player prefers to wait until his form changes */
            if(config.Game.reactionStateLog)
              console.log(state.timestamps);
            state.timestamps[state.subj] += 1;
            var asubj = getActiveSubjects(state);
            if(config.Game.reactionStateLog) {
              console.log("active subjects");
              console.log(asubj);
            }
            // shift curTime if necessary
            if(asubj.length == 0) {
              state.curTime = _.min(_.values(state.timestamps));
              asubj = subjects;
            }
            if(config.Game.reactionStateLog) {
              console.log("active subjects");
              console.log(asubj);
            }
            state.subj = asubj[0]; //TODO: should we choose randomly?
            if(config.Game.reactionStateLog) {
              console.log("The next state: ");
              console.log(state);
              console.log("introduceTime reaction end");
            }
            return state;
          } else {
            /* v =!= "WAIT" */
            var r = fr.reaction(v);
            if(r.subj === undefined) {
              /* no next player specified */
              var asubj = getActiveSubjects(r);
              // shift curTime if necessary
              if(asubj.length == 0) {
                state.curTime = _.min(_.values(state.timestamps));
                asubj = subjects;
              }
              r.subj = asubj[0]; //TODO: should we choose randomly?
            }
            /* copy time information */
            r.curTime = state.curTime;
            r.timestamps = state.timestamps;
            if(config.Game.reactionStateLog) {
              console.log("introduceTime reaction finished with…");
              logState(r);
            }
            return r;
          }
        }
      };
    };
    /* extend state with curTime (0 by default) and timestamps object */
    /* this.extendState(function(state) {
      if(!state.curTime) state.curTime = 0;
      if(!state.timestamps) state.timestamps = {};
      this.subjects.forEach(function(sj) {
        if(!state.timestamps[sj])
          state.timestamps[sj] = state.curTime;
      });
    }, _.identity); */
    return this;
  },
  
  /**
   * Game transformation:
   * record states to an array in order to save a history.
   * @return Game
   */
  stateRecording: function() {
    var getFormReaction1 = this.getFormReaction;
    this.getFormReaction = function(state) {
      var fr = getFormReaction1(state);
      if(!fr) return fr;
      return {
        form: fr.form,
        reaction: function(v) {
          var r = fr.reaction(v);
          var r$ = undefined; //_.cloneDeep(r);
          if(!r.rec) r.rec = [];
          r.rec = _.clone(r.rec);
          r.rec.push({
            v: v,
            r: r$
          });
          return r;
        }
      }
    };
    return this;
  }
  
};

module.exports = Game;
